import { css, Global } from '@emotion/react';
import { ThemeProvider as ThemeProviderTKv3 } from '@tablecheck/tablekit-react';
import { ThemeProvider } from '@tablekit/theme';
import { commonTypographyStyles } from '@tablekit/typography';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { ErrorBoundary } from 'ErrorBoundary';
import { MainLayout } from 'components/MainLayout';
import { FailedPage } from 'pages/Failed';
import { ForgotPasswordPage } from 'pages/ForgotPassword';
import { ResetPasswordPage } from 'pages/ResetPassword';
import { SignInPage } from 'pages/SignIn';
import { SingleSignOn } from 'pages/SingleSignOn';
import { useAuthorizationWatcher } from 'useAuthorizationWatcher';
import { animationStyles } from 'utils/animation.styles';
import { ROUTES } from 'utils/constants';

export function Router(): JSX.Element {
  useAuthorizationWatcher();
  const [, { language }] = useTranslation();

  return (
    <ThemeProvider locale={language}>
      <ThemeProviderTKv3 lang={language} theme="light">
        <Global
          styles={css`
            ${commonTypographyStyles};
            ${animationStyles};
          `}
        />
        <ErrorBoundary>
          <BrowserRouter>
            <Switch>
              <Route path="/:locale" exact>
                <MainLayout>
                  <SignInPage />
                </MainLayout>
              </Route>
              <Route path={`/:locale/${ROUTES.SSO}`} exact>
                <MainLayout>
                  <SingleSignOn />
                </MainLayout>
              </Route>
              <Route path={`/:locale/${ROUTES.FORGOT_PASSWORD}`}>
                <MainLayout>
                  <ForgotPasswordPage />
                </MainLayout>
              </Route>
              <Route path={`/:locale/${ROUTES.RESET_PASSWORD}`}>
                <MainLayout>
                  <ResetPasswordPage />
                </MainLayout>
              </Route>
              <Route path={`/:locale/${ROUTES.UNLOCK_ACCOUNT}`}>
                <MainLayout>
                  <SignInPage isUnlockAccount />
                </MainLayout>
              </Route>
              <Route path={`/:locale/${ROUTES.FAILED}`}>
                <MainLayout>
                  <FailedPage />
                </MainLayout>
              </Route>
            </Switch>
          </BrowserRouter>
        </ErrorBoundary>
      </ThemeProviderTKv3>
    </ThemeProvider>
  );
}
